import type { VoidFunctionComponent } from 'react';

import { ignoredAtFromProjects, ignoredKindsFromProjects } from '../../../../helpers/issuesV2';
import VulnBadge from '../../../generic/VulnBadge';
import { areAnyProjectsReachable } from '../../utils';
import type { VulnIssue } from '../../../../../shared/issuesV2';

import BaseIssueItem from './BaseIssueItem';
import VulnerabilityIssueItemContent from './BaseIssueItem/VulnerabilityIssueItemContent';

type VulnerabilityIssueItemProps = {
  issue: VulnIssue;
};

/**
 * Represents a Vulnerability issue (which is a type of security issue).
 */
const VulnerabilityIssueItem: VoidFunctionComponent<VulnerabilityIssueItemProps> = ({ issue }) => (
  <BaseIssueItem id={issue.id} issue={issue}>
    <VulnerabilityIssueItemContent
      issue={issue}
      locator={issue.source.id}
      title={issue.title}
      createdAt={issue.createdAt}
      ignoredAt={ignoredAtFromProjects(issue.projects)}
      dependency={issue.source.name}
      version={issue.source.version}
      tickets={issue.jiraTickets}
      packageManager={issue.source.packageManager}
      cve={issue.cve}
      exploitability={issue.exploitability}
      epss={issue.epss}
      remediation={issue.remediation}
      depths={issue.depths}
      ignoredKinds={ignoredKindsFromProjects(issue.projects)}
      badge={<VulnBadge cvss={issue.cvss} isTruncated={false} />}
      isReachable={areAnyProjectsReachable(issue.projects)}
    />
  </BaseIssueItem>
);

export default VulnerabilityIssueItem;
